import { render, staticRenderFns } from "./MiniDepStatTableDepBrokers.component.vue?vue&type=template&id=8576c166&scoped=true&"
import script from "./MiniDepStatTableDepBrokers.component.vue?vue&type=script&lang=js&"
export * from "./MiniDepStatTableDepBrokers.component.vue?vue&type=script&lang=js&"
import style0 from "./MiniDepStatTableDepBrokers.component.vue?vue&type=style&index=0&id=8576c166&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8576c166",
  null
  
)

export default component.exports